import React from 'react';
import './ProjectCard.css';

const ProjectCard = ({
  title = 'Rénovation Pavillon H au CHU Lyon Edouard Herriot',
  images = [],
}) => {
  let columnClass = 'two-col'; // default

  if (images.length === 3) {
    columnClass = 'two-col';}
 else if (images.length === 1) {
    columnClass = 'one-col';
  } else if (images.length >= 7) {
    columnClass = 'four-col';
  } else if (images.length >= 5) {
    columnClass = 'three-col';
  }

  return (
    <div className="project-card">
        <div className="project-title">
      <h2 >{title}</h2></div>
      <div className={`image-grid ${columnClass}`}>
        {images.map((src, index) => (
          <img key={index} src={src} alt={`Innovation ${index + 1}`} />
        ))}
      </div>
    </div>
  );
};

export default ProjectCard;
